// extracted by mini-css-extract-plugin
export default {"dayName":"DaysMenuItem_dayName__96mfo","allDays":"DaysMenuItem_allDays__Iy3UL","dropdownContainer":"DaysMenuItem_dropdownContainer__7i+o1","dayTime":"DaysMenuItem_dayTime__pd6VQ"};